import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'fgb-tier-level-progress',
  templateUrl: './tier-level-progress.component.html',
  styleUrl: './tier-level-progress.component.scss',
})
export class TierLevelProgressComponent implements OnInit, OnChanges {
  @Input() Tier: any;
  @Input() TierAchieved: any[] = [];
  @Input() isLast: boolean = false;
  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['Tier'] && changes['Tier'].currentValue) {
      //add comma for big number
      const newValue = changes['Tier'].currentValue;
      this.Tier = {
        ...newValue,
        MinimumTierPoints: this.Tier.MinimumTierPoints.toLocaleString(),
        MaximumTierPoints: this.Tier.MaximumTierPoints.toLocaleString(),
      };
    }
  }

  checkTier(): boolean {
    const tierIndex = this.TierAchieved.findIndex(
      (tier) => tier.Name.toLowerCase().trim() === this.Tier.Name.toLowerCase().trim()
    );
    return tierIndex !== -1;
  }

  getLowerTierName(): string {
    return this.Tier.Name.toLowerCase();
  }
}
